import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb586f00")

_pushScopeId("data-v-fb586f00")
const _hoisted_1 = { class: "SelectAndSearch__select" }
const _hoisted_2 = { class: "SelectAndSearch__icon-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", {
    class: ["SelectAndSearch", {
      'SelectAndSearch--active': _ctx.active,
    }]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.selectable)
        ? (_openBlock(), _createBlock("select", {
            key: 0,
            value: _ctx.category,
            onInput: _cache[1] || (_cache[1] = $event => (_ctx.select($event))),
            class: "SelectAndSearch__select-item"
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock("option", {
                key: `item-${item.id}`,
                value: item.id
              }, _toDisplayString(item.name), 9, ["value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 40, ["value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Icon, {
        type: _ctx.IconType.IC_18_DOWN,
        size: 18
      }, null, 8, ["type"])
    ]),
    _createVNode("input", {
      class: "SelectAndSearch__control",
      placeholder: _ctx.placeholder,
      maxlength: _ctx.maxlength,
      value: _ctx.keyword,
      onFocus: _cache[2] || (_cache[2] = $event => (_ctx.active = true)),
      onBlur: _cache[3] || (_cache[3] = $event => (_ctx.active = false)),
      onInput: _cache[4] || (_cache[4] = $event => (_ctx.$emit('update:keyword', $event.target.value))),
      onKeyup: _cache[5] || (_cache[5] = _withKeys((...args) => (_ctx.search(...args)), ["enter"]))
    }, null, 40, ["placeholder", "maxlength", "value"]),
    _createVNode("button", _hoisted_2, [
      _createVNode("div", {
        class: "SelectAndSearch__touch-area",
        onClickCapture: _cache[6] || (_cache[6] = (...args) => (_ctx.search(...args)))
      }, null, 32),
      (!_ctx.active)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            type: _ctx.IconType.IC_18_SEARCH,
            size: 18
          }, null, 8, ["type"]))
        : (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            type: _ctx.IconType.IC_18_SEARCH_PRESS,
            size: 18
          }, null, 8, ["type"]))
    ])
  ], 2))
})